import { useParams } from 'react-router-dom'
import { getCustomerOrdersAwaitingValidation } from '@/services/api'
import { CustomerOrderTable } from '@/features/sales-order/components/CustomerOrderTable'
import { salesOrderListQueryKeys } from '@/features/sales-order/salesOrderQueries'

export function AwaitingValidationPage() {
  const { workflowId } = useParams<{ workflowId: string }>()

  return (
    <CustomerOrderTable
      queryKeyPrefix={salesOrderListQueryKeys.awaitingValidation(workflowId ?? '')}
      fetchList={getCustomerOrdersAwaitingValidation}
      emptyMessage="No customer orders awaiting validation"
    />
  )
}
